<template>
    <!--<the-search-bar />-->
    <div v-if="disabledMaintenance">
        <span style="color: rgb(246, 139, 57); font-size: 18px; padding-left: 6rem;">We are under maintenance from 22<sup>nd</sup> Jan. 2023 13:00 to 16:00 (GMT+8) Sorry for your inconvience.</span><br />
    </div>
    <div class="p-5">
        <div>
            <base-button label="Back" @click="goBack" />
        </div>
        <Divider id="rountingdivider" />
        <!-- <Divider  /> -->
        <div v-if="showcontent">
            <div class="grid">
                <div class="col-12 md:col-6 lg:col-2">
                    <h3>{{ titleMode }}</h3>
                    <p>{{ pMode }}</p>
                </div>
                <div class="col-12 md:col-6 lg:col-2">
                    <h3>{{ titleHouse }}</h3>
                    <p>
                        {{ pHouse }}
                    </p>
                </div>
                <div class="col-12 md:col-6 lg:col-2">
                    <h3>{{ titleOrigin }}</h3>
                    <p>{{ pOrigin }}</p>
                </div>
                <div class="col-12 md:col-6 lg:col-2">
                    <h3>{{ titleDestination }}</h3>
                    <p>{{ pDest }}</p>
                </div>
                <div class="col-12 md:col-6 lg:col-2">
                    <h3>{{ titleQuantity }}</h3>
                    <p>{{ pQuantity }}</p>
                </div>
                <div class="col-12 md:col-6 lg:col-2">
                    <h3>{{ titleUnit }}</h3>
                    <p>{{ pUnit }}</p>
                </div>
                <div v-if="isShowCFS" class="col-12 md:col-6 lg:col-2">
                    <h3>{{ titleCustomsEntryNo }}</h3>
                    <p>{{ customsEntryNo }}</p>
                </div>
                <div v-if="isShowCFS" class="col-12 md:col-6 lg:col-2">
                    <h3>{{ titleCfsLastFreeDay }}</h3>
                    <p>{{ cfsLastFreeDay }}</p>
                </div>
                <div v-if="isShowCFS" class="col-12 md:col-6 lg:col-2">
                    <h3>{{ titleGoDate }}</h3>
                    <p>{{ goDate }}</p>
                </div>
            </div>
            <Divider />
            <h2 style="padding: 1rem 0; "><i class="pi pi-map" style="fontSize: 1.5rem; margin-top: 20px"></i> Milestones</h2>            
            <div>
                <!-- <DataTable :value="products" responsiveLayout="scroll">
            <Column field="code" header="Code"></Column>
            <Column field="name" header="Name"></Column>
            <Column field="category" header="Category"></Column>
            <Column field="quantity" header="Quantity"></Column>
        </DataTable> -->
                <DataTable :value="milestonelist" responsiveLayout="scroll">
                    <Column field="Milestone" header="Milestone"></Column>
                    <Column field="Location" header="Location"></Column>
                    <Column field="MilestoneTime" header="Date/Time"></Column>
                </DataTable>
            </div>

            <Divider id="rountingdivider" />
            <h2 style="padding: 1rem 0; ">
                    <i class="pi pi-map-marker" style="fontSize: 1.5rem; margin-top: 20px"></i> Routing Information
                    <img alt="Tracking" v-if="showIcon" @click="openBingMaps" src="../../assets/images/Dimerco_icons-Map.png" style="width: 45px; height: 45px; position: fixed; cursor: pointer " />               
                
            </h2>
            <DataTable :value="Routinglist" responsiveLayout="scroll">
                <!-- <Column field="From" header="From"></Column>
          <Column field="To" header="To"></Column>
          <Column field="FrightNo" header="Flight / Truck"></Column>
          <Column field="ETD" header="ETD"></Column>
          <Column field="ATD" header="ATD"></Column>
          <Column field="ETA" header="ETA"></Column>
          <Column field="ATA" header="ATA"></Column> -->
                <Column v-for="col of columns"
                        :field="col.field"
                        :header="col.header"
                        :key="col.field"></Column>
            </DataTable>
        </div>
        <div class="NoTrackingDataView" v-if="NoTrackingData">
            <div>
                <img src="../../assets/No_TrackAndTrace.svg" />
            </div>
            <div><h3>Tracking Number Doesn’t Exist</h3></div>
            <div>Please try another one.</div>
        </div>
    </div>
    <loading loader="Spinner"
             v-model:active="isLoading"
             :can-cancel="false"
             :is-full-page="true">
        <div class="loadingio-spinner-rolling-337s1ps6cdo">
            <div class="ldio-mrl912uegd">
                <div></div>
            </div>
        </div>
    </loading>
</template>

<script>
import ProductService from "../../Service/ProductService";
    import moment from 'moment-timezone'
    export default {
        props: {
            code: {
                type: String,
                required: true,
            },
        },
        watch: {
            // code(newCode) {
            // this.getTrackingData(newCode);
            // },
        },
        data() {
            return {
                trackingNo: null,

                //milestone grid
                milestonelist: null,

                //carrier booking grid
                Routinglist: null,
                columns: null,
                //Show Track and Trace data or not.
                showcontent: true,
                NoTrackingData: false,
                //When Loading
                isLoading: false,
                //header title
                titleMode: "Mode",
                titleHouse: "House No.",
                titleOrigin: "Origin",
                titleDestination: "Destination",
                titleQuantity: "Quantity",
                titleUnit: "Weight",
                titleCustomsEntryNo: "Customs Entry#",
                titleCfsLastFreeDay: "CFS Last Free Day",
                titleGoDate: "GO Date",

                //header value
                pMode: null,
                pHouse: null,
                pOrigin: null,
                pDest: null,
                pQuantity: null,
                pUnit: null,
                needCache: false,
                disabledMaintenance: false,
                showIcon: false,
                customsEntryNo:null,
                cfsLastFreeDay:null,
                goDate:null,
                isShowCFS:false
            };
        },
        productService: null,
        created() {
            // this.trackingNo = this.$route.query.KeyValue;

            this.productService = new ProductService();
            const currentDate = moment.tz('Asia/Taipei').unix();
            const DueDate = moment.utc('2023-01-22T07:00:00.000').unix();
            if (DueDate > currentDate) {
                this.disabledMaintenance = true;
            }
        },
        mounted() {            
            const url = window.location.href.split("/");
            const location = url[url.length - 1].split("?");            
            this.trackingNo = location[0];
            this.needCache = this.$route.query.cache && this.$route.query.cache === 'no' ? false : true;
            //this.productService.getProductsSmall().then(data => this.products = data);
            //this.productService.getTrackAndTraceDataAPI().then(data => this.products = data);
            // this.trackingNo = this.code;
            if (this.trackingNo != null) {
                this.getTrackingData(location[location.length - 1]);
            } else {
                this.showNoTrackingData();
            }

        },
        methods: {
            //Update by Ziv at 2023/11/22 VAL-12940 Open Bing Map
            openBingMaps() {
                var paras = {
                    KeyValue: this.trackingNo,
                    PL: this.pMode
                };
                this.productService.getGPSUrlWithKeyvalue(paras).then((data) => {
                    window.open(data, "_blank");
                });
            },
            showNoTrackingData() {
                this.showcontent = false;
                this.NoTrackingData = true;
            },
            showShipmentData() {
                this.showcontent = true;
                this.NoTrackingData = false;
            },
            getTrackingData() {
                this.isLoading = true;
                var paras = {
                    KeyValue: this.trackingNo,
                };
                this.productService.getTrackAndTraceDataAPI(paras).then((data) => {                    
                    this.isLoading = false
                    if (data.ReturnMSG.errorCode < 0) {
                        this.showNoTrackingData();
                        this.pMode = null;
                        this.pHouse = null;
                        this.pOrigin = null;
                        this.pDest = null;
                        this.pQuantity = null;
                        this.pUnit = null;
                        this.milestonelist = null;
                        this.Routinglist = null;
                        this.customsEntryNo = null;
                        this.cfsLastFreeDay = null;
                        this.goDate = null;
                        this.isLoading = false;
                        return;
                    } else {
                        this.showShipmentData();
                    }

                    if (data.AMSTrackingData != null) {
                        this.columns = [
                            { field: "From", header: "From" },
                            { field: "To", header: "To" },
                            { field: "FrightNo", header: "Flight / Truck" },
                            { field: "ETD", header: "ETD" },
                            { field: "ATD", header: "ATD" },
                            { field: "ETA", header: "ETA" },
                            { field: "ATA", header: "ATA" },
                        ];

                        this.titleUnit = "Weight";
                        this.pMode = data.AMSTrackingData.ShipmentHeader.Mode;
                        this.pHouse = data.AMSTrackingData.ShipmentHeader.HouseNo;
                        this.pOrigin = data.AMSTrackingData.ShipmentHeader.Origin;
                        this.pDest = data.AMSTrackingData.ShipmentHeader.Destination;
                        this.pQuantity = data.AMSTrackingData.ShipmentHeader.Quantity;
                        this.pUnit =
                            data.AMSTrackingData.ShipmentHeader.Weight +
                            " " +
                            data.AMSTrackingData.ShipmentHeader.WeightUOM;
                        this.milestonelist = data.AMSTrackingData.MilestonesData;
                        this.Routinglist = data.AMSTrackingData.RoutingInfoData;
                        this.isLoading = false;
                    }
                    if (data.OMSTrackingData != null) {
                        this.columns = [
                            { field: "RouteType", header: "Route Type" },
                            { field: "ShippingMode", header: "Shipping Type" },
                            { field: "OrgCode", header: "From" },
                            { field: "DSTNCode", header: "To" },
                            { field: "Vessel", header: "Vessel" },
                            { field: "Voyage", header: "Voyage" },
                            { field: "ETDTime", header: "ETD" },
                            { field: "ATDTime", header: "ATD" },
                            { field: "ETATime", header: "ETA" },
                            { field: "ATATime", header: "ATA" },
                        ];

                        this.pMode = data.OMSTrackingData.ShipmentHeader.Mode;
                        this.pHouse = data.OMSTrackingData.ShipmentHeader.HouseNo;
                        this.pOrigin = data.OMSTrackingData.ShipmentHeader.Origin;
                        this.pDest = data.OMSTrackingData.ShipmentHeader.Destination;
                        this.pQuantity = data.OMSTrackingData.ShipmentHeader.Quantity;
                        if (data.OMSTrackingData.ShipmentHeader.TEU != null) {
                            this.titleUnit = "Container";
                            this.pUnit = data.OMSTrackingData.ShipmentHeader.TEU;
                        } else {
                            this.titleUnit = "CBM";
                            this.pUnit = data.OMSTrackingData.ShipmentHeader.CBM;
                        }
                        this.milestonelist = data.OMSTrackingData.MilestonesData;
                        this.Routinglist = data.OMSTrackingData.RoutingInfoData;
                        this.customsEntryNo = data.OMSTrackingData.ShipmentHeader.CustomsReleaseNo;
                        this.cfsLastFreeDay = data.OMSTrackingData.ShipmentHeader.CFSLastFreeDay;
                        this.goDate = data.OMSTrackingData.ShipmentHeader.GODate;
                        if (this.customsEntryNo !== '' && this.customsEntryNo !== null ||
                          this.cfsLastFreeDay !== '' && this.cfsLastFreeDay !== null ||
                          this.goDate !== '' && this.goDate !== null)
                        {
                            this.isShowCFS = true;
                        }
                        this.isLoading = false;

                        //Check Existed GPS by Ziv at 2023/11/22
                        this.ExistedGPSInfo(this.trackingNo, "Ocean");
                    }
                    //Update by Harry at 2021/12/13, VAL-8509, track and trace add DAS Mode for tracking.
                    if (data.DASTrackingData != null) {
                        this.columns = [
                            { field: "From", header: "From" },
                            { field: "To", header: "To" },
                            { field: "FrightNo", header: "Flight / Truck" },
                            { field: "ETD", header: "ETD" },
                            { field: "ATD", header: "ATD" },
                            { field: "ETA", header: "ETA" },
                            { field: "ATA", header: "ATA" },
                        ];

                        this.titleUnit = "Weight";
                        this.pMode = data.DASTrackingData.ShipmentHeader.Mode;
                        this.pHouse = data.DASTrackingData.ShipmentHeader.HouseNo;
                        this.pOrigin = data.DASTrackingData.ShipmentHeader.Origin;
                        this.pDest = data.DASTrackingData.ShipmentHeader.Destination;
                        this.pQuantity = data.DASTrackingData.ShipmentHeader.Quantity;
                        this.pUnit =
                            data.DASTrackingData.ShipmentHeader.Weight +
                            " " +
                            data.DASTrackingData.ShipmentHeader.WeightUOM;
                        this.milestonelist = data.DASTrackingData.MilestonesData;
                        this.Routinglist = data.DASTrackingData.RoutingInfoData;
                        this.isLoading = false;
                    }
                    if (data.TMSTrackingData != null) {                        
                        this.columns = [
                            { field: 'availablePickup', header: 'Available Pickup' },
                            { field: 'actualPickup', header: 'Actual Pickup' },
                            { field: 'availalbeDelivery', header: 'Available Delivery' },
                            { field: 'actaulDelivery', header: 'Actual Delivery' },
                        ];
                        this.titleUnit = "Weight";
                        this.pMode = data.TMSTrackingData.ShipmentHeader.Mode;
                        this.pHouse = data.TMSTrackingData.ShipmentHeader.HouseNo;
                        this.pOrigin = data.TMSTrackingData.ShipmentHeader.Origin;
                        this.pDest = data.TMSTrackingData.ShipmentHeader.Destination;
                        this.pQuantity = data.TMSTrackingData.ShipmentHeader.Quantity;
                        this.pUnit = data.TMSTrackingData.ShipmentHeader.Weight + " " + data.TMSTrackingData.ShipmentHeader.WeightUOM;
                        this.milestonelist = data.TMSTrackingData.MilestonesData;
                        this.Routinglist = data.TMSTrackingData.RoutingInfoData;
                        this.pPONo = data.TMSTrackingData.ShipmentHeader.PONo;
                        this.pPODName = data.TMSTrackingData.ShipmentHeader.PODName;
                    }
                    //Update by Ziv at 2023/9/26, VAL-12496, track and trace add RMS Mode for tracking.
                    if (data.RMSTrackingData != null) {
                        this.columns = [
                            { field: "OrgCode", header: "From" },
                            { field: "DSTNCode", header: "To" },
                            { field: "TrainNo", header: "Train" },
                            { field: "CTNRNo", header: "Container" },
                            { field: "ETDTime", header: "ETD" },
                            { field: "ATDTime", header: "ATD" },
                            { field: "ETATime", header: "ETA" },
                            { field: "ATATime", header: "ATA" },
                        ];

                        this.pMode = data.RMSTrackingData.ShipmentHeader.Mode;
                        this.pHouse = data.RMSTrackingData.ShipmentHeader.HouseNo;
                        this.pOrigin = data.RMSTrackingData.ShipmentHeader.Origin;
                        this.pDest = data.RMSTrackingData.ShipmentHeader.Destination;
                        this.pQuantity = data.RMSTrackingData.ShipmentHeader.Quantity + ' ' + data.RMSTrackingData.ShipmentHeader.QuantityUOM;
                        this.titleUnit = "Weight";
                        this.pUnit = data.RMSTrackingData.ShipmentHeader.Weight + ' ' + data.RMSTrackingData.ShipmentHeader.WeightUOM;
                        this.milestonelist = data.RMSTrackingData.MilestonesData;
                        this.Routinglist = data.RMSTrackingData.RoutingInfoData;
                        this.isLoading = false;

                        //Check Existed GPS by Ziv at 2023/11/22
                        this.ExistedGPSInfo(this.trackingNo, "Railway");
                    }
                });

            },
            goBack() {  
                if (this.needCache == true) {
                    window.history.go(-1);
                } else {
                    this.$router.push('/TrackAndTrace');
                }                
            },
            //Update by Ziv at 2023/11/22 VAL-12940 Tracking GPS in Bing Map
            ExistedGPSInfo(pKV, pPL) {
                var paras = {
                    KeyValue: pKV,
                    PL: pPL
                };
                this.productService.ExistedGPS(paras).then((data) => {
                    this.showIcon = data;
                });
            }
        },
    };
</script>

<style scoped>
* {
  font-size: 16px;
}

.p-datatable .p-datatable-thead > tr > th {
  padding: 2px;
}

.grid {
  /* padding: 1rem 0 */
  padding-top: 0rem;
  padding-bottom: 0rem;
  padding-left: 3rem;
  padding-right: 3rem;
}

h3 {
  margin: 0;
}

p {
  margin-top: 0.5rem;
}

h2 {
  margin: 0;
  padding-left: 3rem;
  padding-bottom: 1rem;
}

.p-datatable-wrapper {
  padding-left: 3rem;
  padding-right: 3rem;
}

/* .p-card-body .p-card-content
  {
    padding: 1rem 0
  }
  .p-card-body .p-card-footer
  {
    padding: 1rem 0
  } */
/*padding: 1rem 0 */

.NoTrackingDataView {
  text-align: center;
  padding-top: 10rem;
  padding-bottom: 10rem;
}

@keyframes ldio-mrl912uegd {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
.ldio-mrl912uegd div {
  position: absolute;
  width: 126px;
  height: 126px;
  border: 10px solid #0a69aa;
  border-top-color: transparent;
  border-radius: 50%;
}
.ldio-mrl912uegd div {
  animation: ldio-mrl912uegd 1s linear infinite;
  top: 100px;
  left: 100px;
}
.loadingio-spinner-rolling-337s1ps6cdo {
  width: 200px;
  height: 200px;
  display: inline-block;
  overflow: hidden;
  background: transparent;
}
.ldio-mrl912uegd {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio-mrl912uegd div {
  box-sizing: content-box;
}

/* generated by https://loading.io/ */
</style>
